var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calendar',_vm._b({on:{"keyup":_vm.onKeyup},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'calendar',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }